<form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="!isTrissUser">
  <!-- FIRST STEP START-->
  <div class="ic1-my-16">
    <ng-ui-kit-accordion
      [disabled]="showStep2"
      [title]="
        'VIRTUAL_TOKEN_PAGE.GENERATE_TOKEN_FORM.STEP_ONE.TITLE' | translate
      "
      [icon]="showStep2 ? 'check' : ''"
      [open]="showStep1"
      [step]="!showStep2 ? 1 : 0">
      <ng-container content>
        <div class="ic1-row">
          <!-- NAME E DESCRIPTION -->
          <div class="ic1-col-12 ic1-col-lg-6">
            <ng-ui-kit-input
              formControlName="name"
              name="name"
              autocomplete="name"
              [placeholder]="
                'VIRTUAL_TOKEN_PAGE.GENERATE_TOKEN_FORM.STEP_ONE.TOKEN_NAME_PLACEHOLDER'
                  | translate
              "
              type="text"
              icName="name"
              icId="name"
              [label]="
                'VIRTUAL_TOKEN_PAGE.GENERATE_TOKEN_FORM.STEP_ONE.TOKEN_NAME_LABEL'
                  | translate
              "
              [disclaimerLabel]="
                'COMMON.VALIDATORS.MIN_CHARS_HINT' | translate: { min: 8 }
              "
              [status]="
                step1Attempted && name.invalid
                  ? 'error'
                  : 'informative'
              ">
            </ng-ui-kit-input>
            <app-field-validator
              *ngIf="step1Attempted"
              [field]="name"
              [formErrors]="formErrors"></app-field-validator>
          </div>

          <div class="ic1-col-12 ic1-col-lg-6">
            <ng-ui-kit-input
              formControlName="description"
              name="description"
              autocomplete="description"
              [placeholder]="
                'VIRTUAL_TOKEN_PAGE.GENERATE_TOKEN_FORM.STEP_ONE.TOKEN_DESC_PLACEHOLDER'
                  | translate
              "
              type="text"
              icName="description"
              icId="description"
              [label]="
                'VIRTUAL_TOKEN_PAGE.GENERATE_TOKEN_FORM.STEP_ONE.TOKEN_DESC_LABEL'
                  | translate
              "
              [disclaimerLabel]="
                'COMMON.VALIDATORS.MIN_CHARS_HINT' | translate: { min: 3 }
              "
              [status]="
                step1Attempted && description.invalid
                  ? 'error'
                  : 'informative'
              ">
            </ng-ui-kit-input>
            <app-field-validator
              *ngIf="step1Attempted"
              [field]="description"
              [formErrors]="formErrors"></app-field-validator>
          </div>
          <!-- SIGNATURES e CHECKBOX -->
          <div class="ic1-col-12 ic1-col-lg-6">
            <ng-ui-kit-input
              formControlName="signatures"
              name="signatures"
              autocomplete="signatures"
              [placeholder]="
                'VIRTUAL_TOKEN_PAGE.GENERATE_TOKEN_FORM.STEP_ONE.SIGN_NUMBER_PLACEHOLDER'
                  | translate
              "
              type="text"
              [OnlyNumbers]
              (input)="onSignaturesInput($event)"
              icName="signatures"
              icId="signatures"
              [label]="
                'VIRTUAL_TOKEN_PAGE.GENERATE_TOKEN_FORM.STEP_ONE.SIGN_NUMBER_LABEL'
                  | translate
              "
              [status]="
                step1Attempted && f['signatures'].invalid
                  ? 'error'
                  : 'informative'
              ">
            </ng-ui-kit-input>
            <app-field-validator
              *ngIf="step1Attempted"
              [field]="f['signatures']"
              [formErrors]="formErrors"></app-field-validator>
          </div>

          <div class="ic1-col-12 ic1-col-lg-6 checkbox-content">
            <ng-ui-kit-checkbox
              icId="c15"
              name="unlimited"
              dimension="large"
              formControlName="unlimited"
              [error]="step1Attempted && unlimited.invalid"
              [label]="'VIRTUAL_TOKEN_PAGE.UNLIMITED_SIGNS' | translate"
              (change)="setUnlimitedSigns($event)">
            </ng-ui-kit-checkbox>
          </div>
          <!-- EXPIRATION DATE -->
          <div class="ic1-col-12 ic1-col-lg-6">
            <ng-ui-kit-input
              formControlName="expirationDate"
              name="expirationDate"
              autocomplete="expirationDate"
              [placeholder]="
                'VIRTUAL_TOKEN_PAGE.GENERATE_TOKEN_FORM.STEP_ONE.EXPIRING_DATE_PLACEHOLDER'
                  | translate
              "
              type="date"
              [attr.min]="minDate"
              icName="expirationDate"
              icId="expirationDate"
              [label]="
                'VIRTUAL_TOKEN_PAGE.GENERATE_TOKEN_FORM.STEP_ONE.EXPIRING_DATE_LABEL'
                  | translate
              "
              [status]="
                step1Attempted && expirationDate.invalid
                  ? 'error'
                  : 'informative'
              ">
            </ng-ui-kit-input>
            <app-field-validator
              *ngIf="step1Attempted"
              [field]="expirationDate"
              [formErrors]="formErrors"></app-field-validator>
          </div>
          <div class="ic1-col-12 buttons-container ic1-mt-16">
            <ng-ui-kit-button
              color="secondary"
              [label]="'COMMON.BUTTON.CANCEL' | translate"
              type="button"
              size="sm"
              (onClick)="closeModal()">
            </ng-ui-kit-button>

            <app-submit-button
              [label]="
                'VIRTUAL_TOKEN_PAGE.GENERATE_TOKEN_FORM.STEP_ONE.GENERATE_TOKEN'
                  | translate
              "
              translate-key="VIRTUAL_TOKEN_PAGE.GENERATE_TOKEN_FORM.STEP_ONE.GENERATE_TOKEN"
              [loading]="loading"
              [disabled]="loading"
              (onClick)="goToSecondStep()">
            </app-submit-button>
          </div>
        </div> </ng-container
    ></ng-ui-kit-accordion>
  </div>
  <!-- SECOND STEP START-->
  <div class="ic1-my-16">
    <ng-ui-kit-accordion
      [disabled]="showStep1"
      [title]="'COMMON.ACCORDION_OTP.TITLE' | translate"
      [open]="showStep2"
      [step]="2">
      <ng-container content
        ><div class="desc ic1-mb-12" translate>COMMON.ACCORDION_OTP.DESC</div>
        <div class="ic1-col-12">
          <div class="ic1-form-group">
            <app-otp-input
              formControlName="otp"
              [error]="step2Attempted && otp.invalid"
              [startTimer]="showStep2"></app-otp-input>
          </div>
          <app-field-validator
            *ngIf="step2Attempted"
            [field]="otp"
            [formErrors]="formErrors"></app-field-validator>
        </div>
        <div class="buttons-container ic1-mt-16">
          <ng-ui-kit-button
            color="secondary"
            [label]="'COMMON.BUTTON.CANCEL' | translate"
            type="button"
            size="sm"
            (onClick)="goToStepOne()">
          </ng-ui-kit-button>
          <app-submit-button
            type="submit"
            [loading]="loading"
            [disabled]="loading"
            [label]="'COMMON.BUTTON.CONFIRM' | translate"
            translate-key="COMMON.BUTTON.CONFIRM"></app-submit-button>
        </div>
      </ng-container>
    </ng-ui-kit-accordion>
  </div>
</form>
<!-- TRISS -->
<form [formGroup]="trissForm" (ngSubmit)="onSubmit()" *ngIf="isTrissUser">
  <!-- FIRST STEP START-->
  <div class="ic1-my-16">
    <ng-ui-kit-accordion
      [disabled]="showStep2"
      [title]="
        'VIRTUAL_TOKEN_PAGE.GENERATE_TOKEN_FORM.STEP_ONE.TITLE' | translate
      "
      [icon]="showStep2 ? 'check' : ''"
      [open]="showStep1"
      [step]="!showStep2 ? 1 : 0">
      <ng-container content>
        <div class="ic1-row">
          <!-- NAME E DESCRIPTION -->
          <div class="ic1-col-12 ic1-col-lg-6">
            <ng-ui-kit-input
              formControlName="trissName"
              name="trissName"
              autocomplete="trissName"
              [placeholder]="
                'VIRTUAL_TOKEN_PAGE.GENERATE_TOKEN_FORM.STEP_ONE.TOKEN_NAME_PLACEHOLDER'
                  | translate
              "
              type="text"
              icName="trissName"
              icId="trissName"
              [label]="
                'VIRTUAL_TOKEN_PAGE.GENERATE_TOKEN_FORM.STEP_ONE.TOKEN_NAME_LABEL'
                  | translate
              "
              [disclaimerLabel]="
                'COMMON.VALIDATORS.MIN_CHARS_HINT' | translate: { min: 8 }
              "
              [status]="
                step1Attempted && trissName.invalid
                  ? 'error'
                  : 'informative'
              ">
            </ng-ui-kit-input>
            <app-field-validator
              *ngIf="step1Attempted"
              [field]="trissName"
              [formErrors]="trissFErrors"></app-field-validator>
          </div>

          <div class="ic1-col-12 ic1-col-lg-6">
            <ng-ui-kit-input
              formControlName="trissDescription"
              name="trissDescription"
              autocomplete="trissDescription"
              [placeholder]="
                'VIRTUAL_TOKEN_PAGE.GENERATE_TOKEN_FORM.STEP_ONE.TOKEN_DESC_PLACEHOLDER'
                  | translate
              "
              type="text"
              icName="trissDescription"
              icId="trissDescription"
              [label]="
                'VIRTUAL_TOKEN_PAGE.GENERATE_TOKEN_FORM.STEP_ONE.TOKEN_DESC_LABEL'
                  | translate
              "
              [disclaimerLabel]="
                'COMMON.VALIDATORS.MIN_CHARS_HINT' | translate: { min: 3 }
              "
              [status]="
                step1Attempted && trissDescription.invalid
                  ? 'error'
                  : 'informative'
              ">
            </ng-ui-kit-input>
            <app-field-validator
              *ngIf="step1Attempted"
              [field]="trissDescription"
              [formErrors]="trissFErrors"></app-field-validator>
          </div>

          <div class="ic1-col-12 buttons-container ic1-mt-16">
            <ng-ui-kit-button
              color="secondary"
              [label]="'COMMON.BUTTON.CANCEL' | translate"
              type="button"
              size="sm"
              (onClick)="closeModal()">
            </ng-ui-kit-button>

            <app-submit-button
              [label]="
                'VIRTUAL_TOKEN_PAGE.GENERATE_TOKEN_FORM.STEP_ONE.GENERATE_TOKEN'
                  | translate
              "
              translate-key="VIRTUAL_TOKEN_PAGE.GENERATE_TOKEN_FORM.STEP_ONE.GENERATE_TOKEN"
              [loading]="loading"
              [disabled]="loading"
              (onClick)="goToSecondStep()">
            </app-submit-button>
          </div>
        </div> </ng-container
    ></ng-ui-kit-accordion>
  </div>
  <!-- SECOND STEP START-->
  <div class="ic1-my-16">
    <ng-ui-kit-accordion
      [disabled]="showStep1"
      [title]="'COMMON.ACCORDION_OTP.TITLE' | translate"
      [open]="showStep2"
      [step]="2">
      <ng-container content
        ><div class="desc ic1-mb-12" translate>COMMON.ACCORDION_OTP.DESC</div>
        <div class="ic1-col-12">
          <div class="ic1-form-group">
            <app-otp-input
              formControlName="trissOtp"
              [error]="step2Attempted && trissOtp.invalid"
              [startTimer]="showStep2"></app-otp-input>
          </div>
          <app-field-validator
            *ngIf="step2Attempted"
            [field]="trissOtp"
            [formErrors]="trissFErrors"></app-field-validator>
        </div>
        <div class="buttons-container ic1-mt-16">
          <ng-ui-kit-button
            color="secondary"
            [label]="'COMMON.BUTTON.CANCEL' | translate"
            type="button"
            size="sm"
            (onClick)="goToStepOne()">
          </ng-ui-kit-button>
          <app-submit-button
            type="submit"
            [loading]="loading"
            [disabled]="loading"
            [label]="'COMMON.BUTTON.CONFIRM' | translate"
            translate-key="COMMON.BUTTON.CONFIRM"></app-submit-button>
        </div>
      </ng-container>
    </ng-ui-kit-accordion>
  </div>
</form>
